import { type SessionRecordingStore } from '../types';
import { logger } from './lib/logger';

/** Stops capture before reporting a sibling-tab logout as an interruption. */
export const interruptForAudioShutdown = (get: () => SessionRecordingStore): void => {
  const state = get();
  const wasCapturing =
    state.status === 'RECORDING' ||
    state.recordingId !== null ||
    state.recorderStreamId !== null ||
    Object.keys(state.chunkRecorders).length > 0 ||
    Boolean(state.captureSlot) ||
    Object.keys(state.backupRecorders).length > 0 ||
    Boolean(state.backupCaptureSlot);
  const onInterrupt = wasCapturing ? state.config?.onInterrupt : undefined;

  logger.warn({
    event_type: 'REMOTE_AUDIO_FENCE_CLOSED',
    details: { wasCapturing },
  });
  void state.teardownForLogout('remote-shutdown');
  onInterrupt?.();
};
